{
  "common": {
    "price": "Prix",
    "open": "Ouvrir",
    "close": "Fermer",
    "high": "Élevé",
    "low": "Faible",
    "bid": "Achat",
    "ask": "Vente",
    "time": "Heure",
    "date": "Date",
    "country": "Pays",
    "name": "Nom",
    "currency": "Devise",
    "yes": "Oui",
    "no": "Non",
    "exchange": "Change",
    "type": "Type",
    "1month": "1 mois",
    "3months": "3 mois",
    "6months": "6 mois",
    "1year": "1 an",
    "messages": {
      "nodata": "Aucune donnée disponible",
      "error": "Une erreur est survenue lors de la récupération des données. Essayez de recharger la page."
    },
    "currencies": {
      "USD": "Dollar américain",
      "CAD": "Dollar canadien"
    },
    "shortMonths": {
      "January": "Janv.",
      "February": "Févr.",
      "March": "Mars",
      "April": "Avr.",
      "May": "Mai",
      "June": "Juin",
      "July": "Juil.",
      "August": "Août",
      "September": "Sept.",
      "October": "Oct.",
      "November": "Nov.",
      "December": "Déc."
    },
    "buttons": {
      "D": "J",
      "2D": "2J",
      "W": "S",
      "2W": "2S",
      "M": "M",
      "3M": "3M",
      "YTD": "AAJ",
      "Y": "A",
      "2Y": "2A",
      "10Y": "10A",
      "max": "Max."
    },
    "buy": "Acheter",
    "sell": "Vendre"
  },
  "WMainIndex": {
    "chart": "Graphique",
    "table": "Tableau",
    "trades": "Opérations",
    "lastClose": "Cours de clôture",
    "turnover": "Taux de rotation",
    "tradedVolume": "Volume échangé",
    "marketTrend": "Tendance du marché",
    "1week": "1 semaine",
    "yearToDate": "Cumul annuel jusqu'à ce jour",
    "captions": {
      "trades": "Tableau affichant les détails des opérations",
      "trend": "Tableau affichant les tendances du marché"
    }
  },
  "WMarketList": {
    "header": {
      "ticker": "Symbole",
      "changePlusMinus": "+/-",
      "changePercentage": "%",
      "histClose": "Cours de clôture historique",
      "sortable": "Triable"
    },
    "messages": {
      "norics": "Pas de données disponibles pour les instruments spécifiés"
    }
  },
  "WMarketTiles": {
    "changePercentage": "% d'évolution",
    "changeAbsolute": "Évolution en valeur absolue",
    "turnover": "Taux de rotation",
    "messages": {
      "norics": "Aucune donnée disponible.",
      "invalidInput": "Configuration d'entrée non valide. Veuillez utiliser le format suivant : setRics([\" .GDAXI \"])"
    },
    "WTickerBand": {}
  },
  "WNewsHeadlines": {
    "placeholders": {
      "symbols": "Ajouter un symbole",
      "topics": "Ajouter un thème",
      "keywords": "Ajouter un mot-clé"
    },
    "labels": {
      "headline": "Titre",
      "source": "Source",
      "keywords": "Mot(s)-clé(s)",
      "symbols": "Symbole(s)",
      "topics": "Thème(s)"
    },
    "messages": {
      "nodata": "Aucun titre trouvé.",
      "incompletedata": "Données manquantes pour afficher la vue sélectionnée."
    }
  },
  "WInterestRate": {
    "messages": {
      "paramsError": "Le nombre de paramètres spécifié pour chaque colonne ne correspond pas."
    }
  },
  "WInstrumentInfo": {
    "header": {
      "totvol": "Volume",
      "bidsize": "Quantité acheteur",
      "asksize": "Quantité vendeur",
      "roundlot": "Taille du lot"
    }
  },
  "WPriceChart": {
    "controls": {
      "placeholder": "Comparer à",
      "dateFrom": "Du",
      "dateTo": "Au"
    },
    "tooltip": {
      "price": "Prix : {VALUE}",
      "volume": "Volume : {VALUE}"
    },
    "labels": {
      "shortDays": {
        "Sunday": "Dim.",
        "Monday": "Lun.",
        "Tuesday": "Mar.",
        "Wednesday": "Mer.",
        "Thursday": "Jeu.",
        "Friday": "Ven.",
        "Saturday": "Sam."
      },
      "inputLabel": {
        "day": "Jour",
        "month": "Mois",
        "year": "Année"
      },
      "inputPlaceholder": {
        "day": "JJ",
        "month": "MM",
        "year": "AAAA"
      }
    }
  },
  "WEstimatesRatios": {
    "analystConsensus": {
      "title": "Consensus des analystes",
      "strongsell": "Fortement à vendre",
      "hold": "Conserver",
      "strongbuy": "Fortement à acheter",
      "targetTitle": "Écart par rapport au prix cible",
      "low": "Plus bas sur 52 semaines",
      "high": "Plus haut sur 52 semaines",
      "tp": "Prix cible",
      "recommendation": "Recommandation",
      "tpfull": "Prix cible",
      "pltg": "Croissance à long-term projetée"
    },
    "titles": {
      "companyInfo": "Renseignments sur l’entreprise",
      "total": "Total",
      "valuationProfit": "Évaluation et rentabilité",
      "forecast": "Prévisions",
      "current": "Actuel",
      "perShareData": "Données par action"
    },
    "table": {
      "marketCap": "Capitalisation boursière mn",
      "sharesOutstanding": "Actions en circulation",
      "commonshare": "Actionnaires ordinaires",
      "enterpriseValue": "Valeur d’entreprise mn",
      "numberEmployees": "Nombre d’employés",
      "pe": "Ratio C/B",
      "ps": "Ratio C/V",
      "pb": "Ratio C/VB",
      "pcf": "Ratio C/CF",
      "peg": "Ratio PEG",
      "earningYield": "Rendement des bénéfices",
      "dividendYield": "Rendement des dividendes",
      "revenue": "Revenu mn",
      "ebit": "EBIT mn",
      "netIncome": "Revenu net mn",
      "gpm": "Marge brute",
      "roe": "Rendement des capitaux propres",
      "eps": "Bénéfice par action",
      "rps": "Revenus par action",
      "bps": "Valeur comptable par action",
      "cfps": "Flux de trésorerie par action",
      "cps": "Trésorerie par action",
      "dividendPerShare": "Dividende par action",
      "captions": {
        "companyInfo": "Tableau des renseignments sur l’entreprise",
        "valuationProfit": "Tableau des ratios de valeur et de rentabilité",
        "perShareData": "Tableau des données par action",
        "total": "Tableau des données totales"
      }
    }
  },
  "WCompanyProfile": {
    "titles": {
      "masterData": "Données de référence",
      "clearingCodes": "Codes de validation",
      "keyDates": "Dates clés",
      "activities": "Activités",
      "management": "Gestion"
    },
    "table": {
      "companyID": "Identifiant de l'entreprise",
      "parValue": "Valeur nominale",
      "sharesOutstanding": "Actions en circulation",
      "marketCap": "Capitalisation boursière en millions",
      "freeFloat": "Flottant en %",
      "employees": "Employés",
      "headquarters": "Siège de l'entreprise",
      "phone": "Téléphone",
      "fax": "Télécopie",
      "internet": "Internet",
      "isin": "ISIN",
      "valor": "Valor",
      "cusip": "CUSIP",
      "finYearEnd": "Fin de l'année fiscale",
      "reportingDateQ1": "Résultats trimestriels I",
      "reportingDateQ2": "Résultats trimestriels II",
      "reportingDateQ3": "Résultats trimestriels III",
      "reportingDateQ4": "Résultats trimestriels IV",
      "reportingDateA": "Rapport annuel préliminaire",
      "captions": {
        "masterData": "Tableau affichant les données de référence",
        "clearingCodes": "Tableau affichant les codes de validation",
        "keyDates": "Tableau affichant les dates clés",
        "activities": "Section affichant les activités",
        "management": "Tableau affichant les informations de gestion"
      }
    }
  },
  "WFundAllocation": {
    "types": {
      "HOLD": "PARTICIPATIONS",
      "INVCNT": "PAYS",
      "ASSTALL": "ALLOCATION D'ACTIFS",
      "INDSECT": "SECTEUR",
      "DEBTQUAL": "QUALITÉ DU DÉBITEUR",
      "MATUR": "MATURITÉ"
    }
  },
  "WFundAvgAnnualReturns": {
    "tableHeaders": {
      "description": "Description",
      "3y": "3 ans",
      "5y": "5 ans",
      "10y": "10 ans",
      "ytd": "Cumul annuel jusqu'à ce jour",
      "inc": "Global"
    },
    "lgcbenchmarkid": "Classement Lipper des fonds"
  },
  "WPriceYieldChart": {
    "price": "Prix",
    "yield": "Rendement",
    "scaling": {
      "absolute": "Valeur absolue",
      "percent": "Pourcentage"
    },
    "chart": {
      "containerLabel": "Ce graphique affiche les données de prix ou de rendement"
    }
  }
}
